import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@material-ui/core'
import React from 'react'

// Bulk-delete guard (2026-07-21): the user must type an exact phrase to enable
// the delete, so a bulk delete is never a single accidental click.
const TypedDeleteDialog = ({ open, count, onClose, onConfirm }) => {
  const [text, setText] = React.useState('')
  const phrase = `delete ${count} line${count === 1 ? '' : 's'}`

  React.useEffect(() => {
    if (open) setText('')
  }, [open])

  const ok = text.trim().toLowerCase() === phrase

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete {count} line{count === 1 ? '' : 's'}?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
          This permanently deletes the selected line{count === 1 ? '' : 's'} and
          cannot be undone. To confirm, type <b>{phrase}</b> below.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          size="small"
          variant="outlined"
          placeholder={phrase}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && ok) onConfirm()
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disableElevation
          disabled={!ok}
          onClick={onConfirm}
          style={{ background: ok ? '#c62828' : undefined, color: ok ? '#fff' : undefined }}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TypedDeleteDialog
